import createAxiosInstance from "../LambdaApiAdministracion";
import { ENVIROMENT } from "../../utilities";

export async function GetFetchAccesos() {
  const axiosInstance = await createAxiosInstance();
  const url = ENVIROMENT === "dev" ? `/admon/secciones/accesos` : `/home/admon/secciones/accesos`;
  const requestConfig = {
    method: "GET", // Cambia el método si es necesario
    url: url,
    headers: {
      "Content-Type": "application/json",
    },
  };

  // Realizar la solicitud Axios usando la instancia personalizada
  return axiosInstance(requestConfig);
}
